
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 19","data-token-name":"heading-1"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.941 15H7.78v-4.71H2.53V15H1.367V5.006H2.53v4.259h5.25v-4.26h1.162V15zm5.594 0h-.95V8.338l.013-.457c.007-.14.017-.283.029-.428a4.934 4.934 0 01-.34.322l-.393.323-.978.785-.51-.662 2.32-1.787h.81V15z","fill":"currentColor"}})])
          )
        }
      }
    